import React, { useState } from "react";
import classes from "./CommunitySlideshow.module.css";
import programs from "./CommunitySlides";

const CommunitySlideshow = (props) => {
  const [slide, setSlide] = useState(0);

  const increaseSlide = () => {
    let current = slide;
    current++;
    console.log(current);

    if (current === programs.length) {
      current = 0;
    }
    if (current < 0) {
      current = programs.length - 1;
    }

    setSlide(current);
  };

  const decreaseSlide = () => {
    let current = slide;
    current--;
    console.log(current);

    if (current === programs.length) {
      current = 0;
    }
    if (current < 0) {
      current = programs.length - 1;
    }

    setSlide(current);
  };

  return (
    <div className={classes.CommunitySlideshow}>
      <img src={programs[slide].img} alt={programs[slide].alt} />
      <div className={classes.Overlay}>
        <div className={classes.Actions}>
          <button onClick={decreaseSlide}>
            <svg
              aria-hidden="true"
              focusable="false"
              data-prefix="fas"
              data-icon="arrow-circle-left"
              className="svg-inline--fa fa-arrow-circle-left fa-w-16"
              role="img"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 512 512"
            >
              <path
                fill="currentColor"
                d="M256 504C119 504 8 393 8 256S119 8 256 8s248 111 248 248-111 248-248 248zm28.9-143.6L209.4 288H392c13.3 0 24-10.7 24-24v-16c0-13.3-10.7-24-24-24H209.4l75.5-72.4c9.7-9.3 9.9-24.8.4-34.3l-11-10.9c-9.4-9.4-24.6-9.4-33.9 0L107.7 239c-9.4 9.4-9.4 24.6 0 33.9l132.7 132.7c9.4 9.4 24.6 9.4 33.9 0l11-10.9c9.5-9.5 9.3-25-.4-34.3z"
              ></path>
            </svg>
            <p className={classes.SrOnly}>Previous</p>
          </button>

          <button onClick={increaseSlide}>
            <svg
              aria-hidden="true"
              focusable="false"
              data-prefix="fas"
              data-icon="arrow-alt-circle-right"
              className="svg-inline--fa fa-arrow-alt-circle-right fa-w-16"
              role="img"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 512 512"
            >
              <path
                fill="currentColor"
                d="M256 8c137 0 248 111 248 248S393 504 256 504 8 393 8 256 119 8 256 8zM140 300h116v70.9c0 10.7 13 16.1 20.5 8.5l114.3-114.9c4.7-4.7 4.7-12.2 0-16.9l-114.3-115c-7.6-7.6-20.5-2.2-20.5 8.5V212H140c-6.6 0-12 5.4-12 12v64c0 6.6 5.4 12 12 12z"
              ></path>
            </svg>
            <p className={classes.SrOnly}>Next</p>
          </button>
        </div>
      </div>
    </div>
  );
};

export default CommunitySlideshow;
